export default function Experience() {
  const experiences = [
    {
      role: "UI/UX Designer & WordPress Developer",
      company: "Smart Contents Nepal Pvt. Ltd. (Smart Contents Co., Ltd., Japan)",
      period: "March 2026 – Present",
      details: [
        "Design UI/UX for Japanese web applications and business platforms using Figma.",
        "Create wireframes, prototypes, and responsive interfaces following Japanese and Western design systems.",
        "Develop and maintain WordPress websites and hostings.",
        "Collaborate with Japanese stakeholders, developers, and cross-functional teams.",
        "Ensure pixel-perfect implementation, accessibility, performance, and responsive design.",
        "Manage WordPress themes, plugins, hosting, and website optimization.",
      ],
    },
    {
      role: "UI/UX Designer & WordPress Developer",
      company: "Aide Ascent Pvt. Ltd.",
      period: "May 2024 – 2026",
      details: [
        "Designed user-friendly web interfaces and responsive websites using Figma and WordPress.",
        "Developed and customized WordPress websites with Elementor.",
        "Collaborated with developers and clients to deliver intuitive digital experiences.",
        "Managed domains, hosting, website deployment, and maintenance.",
        "Improved website performance, responsiveness, and SEO.",
      ],
    },
  
  ];

  return (
    <section className="w-full min-h-screen bg-white flex flex-col justify-center pt-4 pb-10 px-3 lg:px-10">
      <div className="max-w-5xl mx-auto">
        {/* Heading */}
        <div className="text-center mb-16">
          <h1 className="text-5xl font-thin text-gray-900 mb-6 leading-tight">
            Experience
            <br />
          </h1>

          <p
            className="text-gray-500 text-lg font-extralight"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            My professional journey and key contributions
          </p>
        </div>

        {/* Experience List */}
        <div className="space-y-14">
          {experiences.map((exp, idx) => (
            <div
              key={idx}
              className="flex flex-col md:flex-row md:items-start md:gap-10"
            >
              {/* Left */}
              <div className="md:w-1/3 mb-4 md:mb-0">
                <h2
                  className="text-2xl font-medium text-gray-900"
                  style={{ fontFamily: "'Poppins', sans-serif" }}
                >
                  {exp.role}
                </h2>

                <p
                  className="text-gray-600 mt-1"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                >
                  {exp.company}
                </p>

                <span
                  className="text-sm text-gray-400"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                >
                  {exp.period}
                </span>
              </div>

              {/* Right */}
              <div
                className="md:w-2/3 space-y-3 text-gray-600 leading-relaxed"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                {exp.details.map((item, i) => (
                  <p key={i}>• {item}</p>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}